import { useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { useResponsive } from "../../../hooks/useResponsive";
import { worklogMissingSchemas } from "../../../schemas/worklogMissing";
import useMutate from "../../../hooks/useMutate";
import { createtMissingWorklog } from "../../../services/apiWorklog";
import {
  createMissingWorklogPayload,
  getLeaveTypeOptions,
} from "../utils/worklogMissingUtils";

export function useWorklogMissingForm({ date, handleClose }) {
  const isMobile = useResponsive("down", "md");
  const currentUser = useSelector((state) => state.users.logInUser);
  const methods = useForm({
    resolver: yupResolver(worklogMissingSchemas),
    defaultValues: {},
  });
  const { mutate, isPending } = useMutate(
    createtMissingWorklog,
    ["worklog-missing"],
    () => {
      handleClose();
    }
  );

  const onSubmit = useCallback(
    (formData) => {
      mutate(
        createMissingWorklogPayload({
          currentUser,
          date,
          formData,
        })
      );
    },
    [currentUser, date, mutate]
  );

  return {
    isMobile,
    isPending,
    leaveTypeOptions: getLeaveTypeOptions(),
    methods,
    onSubmit,
  };
}
